<template>
  <partner-layout :spinning="isLoading">
    <partner-project-layout :model="model">
      <template #underInfo>
        <div class="partner-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :partner-mode="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <div class="project-management__tasks">
        <task-item-list
          :task-status="PROJECT_TASK_STATUS_ALL"
          :project-status-id="model.projectStatusId"
          :show-availability="false"
          :disabled="true"
          :partner-mode="true"
        />
      </div>
    </partner-project-layout>
  </partner-layout>
</template>

<script setup>
  import { onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import PartnerLayout from '@/layouts/PartnerLayout.vue';
  import PartnerProjectLayout from '@/views/partner/projects/components/PartnerProjectLayout';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';
  import { PROJECT_TASK_STATUS_ALL } from '@/api/models/ProjectTaskStatus';
  import TaskItemList from '@/components/projects/management/TaskItemList.vue';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: 'Новый проект',
    description: '',
    projectType: '',
    requestId: null,
    status: {
      type: 'draft',
      text: 'Черновик',
    },
    projectStatusId: null,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const isLoading = ref(true);

  onMounted(async () => {
    await getModel();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.partnerProject.getProject(route.params.id);
      model.id = response.project.id;
      model.name = response.project.name;
      model.number = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  * {
    font-family: 'Nunito Sans', sans-serif;
    margin: 0;
  }

  .partner-project__common-progress {
    margin-top: 42px;
  }

  .project-management {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 100px;

    .project-management__title {
      .project-name {
        margin-top: 15px;
        margin-right: 15px;
      }
    }

    .project-management__info {
      align-items: center;
      margin-top: 40px;

      .project-type,
      .project-description {
        color: $color-text-secondary-grey;
        font-size: 16px;
        font-weight: 700;
        line-height: 26px;
      }

      .project-description {
        margin-top: 10px;

        .project-number {
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
        }
      }

      .project-link {
        text-align: right;
      }
    }

    .project-management__filter-panel {
      margin-top: 40px;
      padding: 8px 40px 8px 20px;
      border-top: 1px solid $color-bg-secondary-grey;
      border-bottom: 1px solid $color-bg-secondary-grey;
    }

    .project-management__tasks {
      margin-top: 40px;
    }
  }
</style>
